import React from 'react';
import {Straight, SwapVert} from "@mui/icons-material";

const SortIconComponent = ({sortOrder})=>{

    return (<>
        {sortOrder === 'ascend' ? (
            <Straight/>
        ) : (sortOrder === 'descend' ? (
            <Straight style={{transform:'rotate(180deg)'}}/>
        ) : (
            <SwapVert/>
        ))}
    </>);
}
export default SortIconComponent;